module.exports = __webpack_public_path__ + "static/media/food-chain-asparagus-pickers-tablet.9f3b0bd3.jpg";